import { createTheme } from '@one-thd/sui-atomic-components';

const BlackFriday2026PrimaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

BlackFriday2026PrimaryTwo.palette['--sui-palette-background-primary'] = '73 73 73';

export { BlackFriday2026PrimaryTwo };